import React, { useState } from "react";

const useETFormState = () => {
  const [formData, setFormData] = useState({
    employeeTwinName: "",
    employeeTwinDescription: "",
    status: "",
    leadPlatform: "",
    area: "",
    subArea: "",
    cluster: "",
    mco: "",
    country: "",
    geoItPartner: "",
    businessOwner: "",
    manualhour: null,
    fte: null,
    softSkill: "",
    transactions: "",
    reporting: "",
    cognitive: "",
    decisionautomations: "",
  });

  const updateForm = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const clearForm = () => {
    setFormData({
      employeeTwinName: "",
      employeeTwinDescription: "",
      status: "",
      leadPlatform: "",
      area: "",
      subArea: "",
      cluster: "",
      mco: "",
      country: "",
      geoItPartner: "",
      businessOwner: "",
      manualhour: null,
      fte: null,
      softSkill: "",
      transactions: "",
      reporting: "",
      cognitive: "",
      decisionautomations: "",
    });
  };

  return { formData, updateForm, clearForm };
};

export default useETFormState;
